import { useState, PropsWithChildren } from 'react';

import { CaseLevel1Code, CaseLevel2Code } from 'shared/constants/common-cases';
import useDispatch from 'shared/hooks/useDispatch';

import { UserCommonCaseCreateForm } from 'pages/incident';
import { setCaseLevels } from 'pages/incident/slice';

import Button from '@mui/material/Button';

const ServiceButtonForm = ({ children }: PropsWithChildren<{}>) => {
  const dispatch = useDispatch();

  const [isOpenedForm, setIsOpenedForm] = useState(false);

  const handleOpenForm = () => {
    setIsOpenedForm(true);
    dispatch(
      setCaseLevels({
        caseLevel1: CaseLevel1Code.Inquiry,
        caseLevel2: CaseLevel2Code.Loans,
      })
    );
  };
  const handleCloseForm = () => setIsOpenedForm(false);

  return (
    <>
      <Button color="success" onClick={handleOpenForm}>
        {children}
      </Button>
      {isOpenedForm && <UserCommonCaseCreateForm onClose={handleCloseForm} />}
    </>
  );
};

export default ServiceButtonForm;
